import { Progress } from '@repo/videa-components/src/index';
import classNames from 'classnames';

interface Props {
  className?: string;
  dmf?: number;
  indicatorClassName?: string;
  isMasked?: boolean;
  minimumValue?: number;
}

export const ToothDamageProgress = ({
  className,
  dmf,
  indicatorClassName,
  isMasked,
  minimumValue = 10,
}: Props) => {
  if (!dmf) return null;

  const dmfPercent = dmf * 100;
  const roundedDmfPercent = Math.round(dmfPercent);

  return (
    <Progress
      data-testid={`tooth-damage-progress`}
      className={classNames(className, 'vai-w-full')}
      indicatorClassName={indicatorClassName}
      indicatorLabel={`${dmfPercent < 5 ? '<5' : roundedDmfPercent}%`}
      isMasked={isMasked}
      value={dmfPercent < minimumValue ? minimumValue : roundedDmfPercent}
    />
  );
};
